// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import { WorkflowTemplateListViewDTO } from '../../../Types/LogT';
import { StringUtils } from '../../../Utils/utils';

const WorkflowTemplateTriggerDescription: FC<{ template: WorkflowTemplateListViewDTO }> = ({ template }) => {
  const { archived, generalWorkflow, runAutomatically, kindsOfInterest, typeOfInterest } = template;

  if (archived) {
    return null;
  }

  const resolveDescription = () => {
    if (generalWorkflow && runAutomatically) {
      return 'Automatisch ausführen';
    }
    if (kindsOfInterest.length > 0 && typeOfInterest) {
      return (
        <>
          Auslösen wenn {i18n._(`events.${typeOfInterest}`)}
          <br />
          Auftragsarten: {StringUtils.concatStrings(kindsOfInterest)}
        </>
      );
    }
    if (kindsOfInterest.length > 0) {
      return `Auftragsarten: ${StringUtils.concatStrings(kindsOfInterest)}`;
    }
    if (typeOfInterest) {
      return `Auslösen wenn ${i18n._(`events.${typeOfInterest}`)}`;
    }
    return null;
  };
  const description = resolveDescription();

  if (!description) {
    return null;
  }
  return (
    <Text mt={3} size={'xs'} color="dimmed" sx={{ wordBreak: 'break-word' }}>
      {resolveDescription()}
    </Text>
  );
};

export default WorkflowTemplateTriggerDescription;
